export class DeviceViewModel {
	id?: number;
	name: string;
	serialNumber?: string;
	endorsementKey?: string;
	tenantId?: number;
	deviceId?: string;
	machineName: string;
	isIotDevice: boolean;
	dcgVersion?: string;
	lastSync: string;
	isProvisioned: boolean;
	provisionDate: string;
	provisioningStatus: string;
	ipAddress?: string;
	modules: DeviceModuleModel[];
	gatewayMachineName?: string;
	deviceType?: DeviceTypeViewModel;
	deviceTypeId: number;
	isGateway?: boolean;
	downstreamDevices?: DeviceViewModel[];
}

export class DeviceModel {
	id?: number;
	name: string;
	machineName: string;
}

export class DeviceModuleModel {
	containerId: string;
	created: string;
	image: string;
	version?: string;
	labels: string;
	moduleName: string;
	mounts: any[];
	networks: any[];
	ports: any[];
	state: string;
	stateFlag?: boolean;
	status: string;
	showStart: boolean;
	showRestart: boolean;
	showStop: boolean;
	showFullSync: boolean;
	showDeltaSync: boolean;
}

export class DeviceTypeViewModel {
	id: number;
	name: string;
}

export enum DeviceType {
	GATEWAY = 'Gateway',
	DOWNSTREAM = 'Downstream',
	SINGLE = 'Single',
}